<template>
  <v-app>
    <v-overlay :model-value="isLoading.main" class="align-center justify-center" scrim="rgba(0,0,0,0.4)">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <router-view v-if="!isLoading.main" />
  </v-app>
</template>

<script>
import { useHead } from '@unhead/vue'
import config from './configs'
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      isLoading: (state) => state.microsite.isLoading
    }),
    ...mapGetters({
      theme: 'microsite/theme'
    })
  },
  setup() {
    useHead({
      link: config.icons.map((href) => ({ rel: 'stylesheet', href }))
    })
  },
  created() {
    this.$vuetify.theme.themes.light.colors.primary = this.theme.primary
    this.$vuetify.theme.themes.light.colors['on-primary'] = this.theme.onPrimary
    this.$vuetify.theme.themes.light.colors.secondary = this.theme.secondary
  }
}
</script>
